import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fiscalYearsApi, FiscalYearDto, CreateFiscalYearRequest, UpdateFiscalYearRequest } from '../api/fiscalYears';

export const useFiscalYears = () => {
  return useQuery<FiscalYearDto[]>({
    queryKey: ['fiscalYears'],
    queryFn: () => fiscalYearsApi.list(),
  });
};

export const useCreateFiscalYear = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (request: CreateFiscalYearRequest) => {
      return await fiscalYearsApi.create(request);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['fiscalYears'] });
    },
  });
};

export const useUpdateFiscalYear = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, request }: { id: number; request: UpdateFiscalYearRequest }) => {
      return await fiscalYearsApi.update(id, request);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['fiscalYears'] });
    },
  });
};
